import { useState } from "react";
import Header from "../components/Header";
import ModalComponent from "../components/Modal";
import Footer from "./Footer";
import { useTranslation } from "react-i18next";

let imagesArr = [
  "/images/filmovi/mfp/1.jpg",
  "/images/filmovi/mfp/2.jpg",
  "/images/filmovi/mfp/3.jpg",
  "/images/filmovi/mfp/4.jpg",
  "/images/filmovi/mfp/5.jpg",
  "/images/filmovi/mfp/6.jpg",
  "/images/filmovi/mfp/7.jpg",
  "/images/filmovi/mfp/8.jpg",
  "/images/filmovi/mfp/9.jpg",
];
const FilmDetails = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const [isImage, setImage] = useState(false);
  const [images, setImages] = useState(imagesArr);
  const [showModal, setShowModal] = useState(false);
  let innerWidth = window.innerWidth;
  const showImage = (tab) => {
    setImage(tab);
  };

  const onClick = (imgRb) => {
    const newImageList = [
      ...imagesArr.slice(imgRb),
      ...imagesArr.slice(0, imgRb),
    ];
    setImages(newImageList);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };
  return (
    <div className="film-details" id="film-details">
      <Header />
      <div className="film-details-all-page">
        <div className="film-details-img">
          <img
            src={
              innerWidth > 600
                ? language === "rs"
                  ? "/images/filmovi/mfp/glavna.jpg"
                  : "/images/filmovi/mfp/glavna_eng.jpg"
                : language === "rs"
                ? "/images/filmovi/mfp/glavna_phone.jpg"
                : "/images/filmovi/mfp/glavna_eng_phone.jpg"
            }
            alt="mfp"
            className="details-img-mfp"
          />
        </div>
        <div className="film-details-menu">
          <button onClick={() => showImage(false)}>
            <div className="film-details-tab" id={!isImage ? "selected" : ""}>
              Trailer
            </div>
          </button>
          <button onClick={() => showImage(true)}>
            <div className="film-details-tab" id={isImage ? "selected" : ""}>
              {t("galerija")}
            </div>
          </button>
        </div>

        {!isImage ? (
          <div className="film-trailer">
            <div className="film-details-video">
              <video className="film-video" controls autoPlay muted loop>
                <source
                  src="/images/filmovi/mfp/MOM_TREJLER_master.mov"
                  type="video/mp4"
                />
              </video>
            </div>
            <div className="img-mfp-trailer">
              <img src="/partneri/partner2.jpg" alt="ison mfp" />
            </div>
          </div>
        ) : (
          <div className="film-trailer">
            <div className="row-img">
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/1.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(0)}
                />
              </div>
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/2.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(1)}
                />
              </div>
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/3.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(2)}
                />
              </div>
            </div>

            <div className="row-img">
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/4.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(3)}
                />
              </div>
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/5.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(4)}
                />
              </div>
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/6.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(5)}
                />
              </div>
            </div>

            <div className="row-img">
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/7.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(6)}
                />
              </div>
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/8.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(7)}
                />
              </div>
              <div className="film-img">
                <img
                  src="/images/filmovi/mfp/9.jpg"
                  alt="ison mfp"
                  onClick={() => onClick(8)}
                />
              </div>
            </div>
          </div>
        )}
        <ModalComponent
          show={showModal}
          handleClose={handleClose}
          images={images}
        />
      </div>

      <Footer />
    </div>
  );
};

export default FilmDetails;
